import type { LiveMapConnection } from '../hooks/use-live-trucks';

const STATES: Record<LiveMapConnection, { text: string; hint: string; dot: string }> = {
  connecting: { text: 'Connecting', hint: 'Opening the live feed.', dot: 'bg-warning' },
  live: { text: 'Live', hint: 'Positions update as they arrive.', dot: 'bg-success' },
  reconnecting: { text: 'Reconnecting', hint: 'The live feed dropped. Positions may be behind until it is back.', dot: 'bg-warning' },
  unavailable: { text: 'Not live', hint: 'The live feed is unavailable. Positions refresh once a minute.', dot: 'bg-muted' },
};

/** Whether what is on the map is moving as it happens. Words as well as a dot: colour is never the only signal. */
export function ConnectionBadge({ connection }: { connection: LiveMapConnection }) {
  const { text, hint, dot } = STATES[connection];
  return (
    <span role="status" aria-label={`Live feed: ${text}`} title={hint} className="inline-flex items-center gap-1.5 text-xs font-medium text-muted">
      <span aria-hidden className={`size-2 rounded-full ${dot}`} />
      {text}
    </span>
  );
}
